import React, { useState } from "react";
import { Modal, Row, Col, Typography, Button } from "antd";
import { ExclamationCircleTwoTone } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const MessageCancelApp = (props) => {
  return (
    <>
      <Paragraph>
        The Detection Application was canceled during its detection process and was not able to gather the necessary
        data to accurately analyze this computer.
      </Paragraph>
      <ul>
        <li>
          <Paragraph>Please allow the Detection Application to complete the detection process.</Paragraph>
        </li>
      </ul>
      <Paragraph>You can retry the detection process (recommended) or go back to the beginning.</Paragraph>
    </>
  );
};

export default MessageCancelApp;
